export default __webpack_public_path__ + "static/N0203-b7478182efcbc982bdd43b101d36ea91.png";